module.exports = __webpack_public_path__ + "static/img/装饰2.0905113.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰2.svg
// module id = gI5Z
// module chunks = 2